import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { Address } from 'viem'
import { EBorrowMoreDialogContentContainer } from './EBorrowMoreDialogContentContainer'

export interface EBorrowMoreDialogProps extends CommonDialogProps {
  liabilityVault: Address
  liabilitySymbol: string
  liabilityDecimals: number
  liabilityAsset: Address
  liabilityLogoURI?: string
  currentDebtFormatted: number
  currentLTV: number
  maxLTV: number
  collateralValueUSD: number
  liabilityPriceUSD: number
  subAccountId?: number
}

function EBorrowMoreDialog({
  open,
  setOpen,
  liabilityVault,
  liabilitySymbol,
  liabilityDecimals,
  liabilityAsset,
  liabilityLogoURI,
  currentDebtFormatted,
  currentLTV,
  maxLTV,
  collateralValueUSD,
  liabilityPriceUSD,
  subAccountId,
}: EBorrowMoreDialogProps) {
  const isWrongNetwork = useWrongNetwork()
  if (isWrongNetwork) {
    setOpen(false)
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <EBorrowMoreDialogContentContainer
          closeDialog={() => setOpen(false)}
          liabilityVault={liabilityVault}
          liabilitySymbol={liabilitySymbol}
          liabilityDecimals={liabilityDecimals}
          liabilityAsset={liabilityAsset}
          liabilityLogoURI={liabilityLogoURI}
          currentDebtFormatted={currentDebtFormatted}
          currentLTV={currentLTV}
          maxLTV={maxLTV}
          collateralValueUSD={collateralValueUSD}
          liabilityPriceUSD={liabilityPriceUSD}
          subAccountId={subAccountId}
        />
      </DialogContent>
    </Dialog>
  )
}

export const eBorrowMoreDialogConfig: DialogConfig<EBorrowMoreDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: EBorrowMoreDialog,
}
